import { Card, CardContent, Typography } from "@mui/material";

const ContractorStatCard = ({
  label,
  value,
  subtitle,
  testId,
  highlight = false,
}) => (
  <Card
    variant="outlined"
    data-testid={testId || "contractor-stat-card"}
    sx={{
      height: "100%",
      ...(highlight
        ? { borderColor: "warning.main", bgcolor: "warning.50" }
        : null),
    }}
  >
    <CardContent>
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>
      <Typography variant="h5" fontWeight={700} sx={{ mt: 0.5 }}>
        {value}
      </Typography>
      {subtitle ? (
        <Typography
          variant="caption"
          color="text.secondary"
          display="block"
          sx={{ mt: 0.5 }}
        >
          {subtitle}
        </Typography>
      ) : null}
    </CardContent>
  </Card>
);

export default ContractorStatCard;
